<template>
  <div class="pass-code">
    <div v-if="qrCode && !onlyCode" class="passcode">
      <div>
        <div class="subHead">
          <van-icon name="arrow-left" class="arrow" @click="goBack" />
          <span class="subHead-text">{{ subHead }}</span>
        </div>
      </div>
      <div class="qrcode">
        <div class="content">
          <div class="header">
            扫描下方二维码即可通行
          </div>
        </div>
        <div class="imageArea">
          <img :src="qrCodeImgUrl" alt="" style="width: 70%; height: 100%; object-fit: cover;" @click="onlyCode = true">
        </div>
        <van-button icon="replay" type="info" @click="refreshQrcode">刷新</van-button>
        <div class="tips">
          <p>温馨提示</p>
          <p>1、此二维码为您的通行凭证，请勿借给他人</p>
          <p>2、动态二维码仅限个人使用，3分钟有效，超时后刷新即可使用</p>
        </div>
      </div>
    </div>
    <transition name="van-fade">
      <div v-if="onlyCode" class="only-code">
        <img :src="qrCodeImgUrl" alt="" @click="onlyCode = false">
      </div>
    </transition>
    <van-dialog v-model="showTipDialog" title="温馨提示" confirm-button-text="我知道了" :before-close="beforeClose" class="tipDialog">
      <p class="diaCode">抱歉，您暂无通行二维码可生成</p>
      <div class="tips">
        <p>二维码生成条件</p>
        <p>1、您已被授予二维码点位通行权限；</p>
        <p>2、您已在后台录入IC卡号信息，IC卡号可虚拟。</p>
      </div>
    </van-dialog>
  </div>

</template>
<script>
import config from '@/common/config';
import { GetUserInfo } from '@/api/user';
import { searchStaff } from '@/api/home';

export default {
  components: {
  },
  data() {
    return {
      showTipDialog: false,
      baseURL:
        process.env.NODE_ENV === 'development'
          ? config.baseUrl.dev
          : config.baseUrl.pro,
      subHead: '通行二维码',
      qrCode: '',
      qrCodeImgUrl: '',
      onlyCode: false
    };
  },
  created() {
    // const { qrCode } = this.$route.query;
    // this.qrCode = qrCode;
    // this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(qrCode)}&timestamp=${new Date().getTime()}`;
    this.getUserInfo();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'user' });
    },
    getUserInfo() {
      const data = {};
      GetUserInfo(data).then(response => {
        if (response.data.personType === 'STAFF') {
          this.personalInfo = response.data;
          this.qrCode = response.data.qr ? response.data.qr : '';
          this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.qrCode)}&timestamp=${new Date().getTime()}`;
          if (!this.qrCode) {
            this.showTipDialog = true;
          }
        } else {
          // this.$router.push({ name: 'match' });
          const info = {
            phone: response.data.phone
          };
          searchStaff(info).then(res => {
            if (res.code === 200) {
              sessionStorage.setItem('staffInfo', JSON.stringify(res.data));
              // this.getUserInfo();
              this.$router.push({ name: 'match' });
            } else {
              this.$router.push({ name: 'unmatch' });
            }
          });
        }
      });
    },
    refreshQrcode() {
      this.qrCodeImgUrl = `${this.baseURL}/wechat/qr/create?content=${encodeURIComponent(this.qrCode)}&timestamp=${new Date().getTime()}`;
    },
    beforeClose(action, done) {
      // done(false) // 不关闭弹框
      if (action === 'confirm') {
        done(); // 关闭
        this.$router.push({ name: 'user' });
      } else if (action === 'cancel') {
        done(); // 关闭
      }
    }
  }
};
</script>
<style lang="less" scoped>

.pass-code {
  height: 100%;
  .passcode {
    background: #EFEFF4;
    .qrcode {
      margin: 15px 20px;
      background: #ffffff;

      .content {
        display: flex;
        justify-content: center;
        .header {
          display: flex;
          justify-content: center;
          background-color: #3B86FF;
          font-size: 0.18rem;
          color: #ffffff;
          padding: 0.13rem 0;
          width: 100%;
        }
      }
      .imageArea {
        display: flex;
        justify-content: center;
        margin-top: 0.2rem;
      }
      .van-button {
        display: flex;
        width: 0.85rem;
        height: 0.3rem;
        line-height: 0.3rem;
        text-align: center;
        margin: 0.15rem auto;
      }

      .tips {
        display: flex;
        flex-direction: column;
        font-size: 0.12rem;
        color: #ffbe00;
        line-height: 0.24rem;
        margin-left: 30px;
        padding-bottom: 30px;
      }
    }
    .imageArea {
      text-align: center;
      margin-top: 0.2rem;
    }
    .van-button {
      display: flex;
      width: 0.85rem;
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: center;
      margin: 0.15rem auto;
    }

    }

  }
  .only-code {
    background-color: #ffffff;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 90%;
      object-fit: cover;
    }
  }

.tipDialog{
  /deep/.van-dialog__content{
    padding:0;
    // text-align: center;
    .diaCode{
      color: #333;
      text-align: center;
      font-size: 0.18rem;
      line-height: 0.3rem;
      height: 0.3rem;
      margin: 0.25rem auto 0rem;
    }
    .tips{
      display: flex;
      flex-direction: column;
      text-align: left;
      font-size: 0.12rem;
      color: #ffbe00;
      line-height: 0.18rem;
      margin-left: 0.30rem;
      // margin-bottom: 0.03rem;
      margin-top: 0.15rem;
    }

  }

}

</style>
